<template>

 <div class="container">
    <h1>
      <!-- <font-awesome-icon icon="home" /> -->
      <b-icon icon="person-square"></b-icon> Your Course

        <div class="float-right" style="margin-top: -62px">
        <b-button
          v-b-modal.modal-help
          v-b-tooltip.hover
          title="Help"
          class="help"
        >
          <b-icon icon="question-square-fill"></b-icon> Help</b-button
        >

<help id="16" />
      </div>
    </h1>
<div class="col-md-12">
  <b-alert show v-if="Cancel &&message==''" variant="success" >Cancelled successfully</b-alert>
 <b-alert v-if="!!message" variant="warning" show>{{this.message}}</b-alert>
  </div>
             <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="empty">
   No Data
   </b-card>
<div v-else v-for="course in Courses" v-bind:Key="course.Serial" class="col-md-4 mb-3">
  <b-card-group deck>
    
    <b-card
      header=''
      header-tag="header"
     
     
      title="Course Description "
    >
    <template #header>
      {{course.CourseNameAr}}
    </template>
    <p>{{course.Description}}</p>
      <b-card-text><strong>Start date: </strong> {{course.StartDate| moment("llll")}}.</b-card-text>
      <b-card-text><strong>End date: </strong> {{course.EndDate| moment("llll")}}</b-card-text>
      <!-- <b-card-text><strong>Result: </strong> </b-card-text> -->
      <b-card-text><strong>Price: </strong> {{course.Price}}</b-card-text>
       <b-card-text><strong>Status: </strong> {{course.CourseStatusEn}}</b-card-text>
         <b-card-text><strong>Paid: </strong> {{course.IsPaid ? "Paid" : "Not Paid"}}</b-card-text>
         <b-card-text><strong>Result : </strong> {{course.IsSuccess == null ? '  --  ' : course.IsSuccess}}</b-card-text>
     <div class="text-center">
      <b-button @click="CancelReservation(course.Serial)"  v-if="course.CourseStatusEn=='New'" class="btn-danger">Cancel</b-button>
       </div>
    </b-card>

   
  </b-card-group>
</div>

<div class="col-md-12 text-right mt-3 mb-4">

   <button class="btn btn-primary" @click="Back">Book Course</button>
   
</div>


<!-- <div class="panal mt-20" style="display:none">
<div class="panal-header">Your Course </div>

 





<div class="table-responsive p-3">
<table class="table table-hover table-bordered">
  <thead class="thead-light">
    <tr>
      <th scope="col" >Course Name AR  </th>
      <th scope="col" >Start date</th>
      <th scope="col" >End date</th>
      <th scope="col" >Result</th>
      <th scope="col" >Action </th>
  
    </tr>
  </thead>

  <tbody>
                  <tr v-if="empty"><td colspan="7"> No Data </td></tr>

     <tr v-else v-for="course in Courses" v-bind:Key="course.Serial">
     <td> {{course.CourseNameAr}}</td>
     <td>{{course.StartDate| moment("llll")}}</td>
     <td>{{course.EndDate| moment("llll")}}</td>
     <td v-if="course.IsSuccess">Success</td>
     <td v-else-if="course.IsSuccess==false">Fail</td>
      <td v-else></td>
     <td> <b-button @click="CancelReservation(course.Serial)"  v-if="course.CourseStatusEn=='New'" class="btn-danger">Cancel</b-button></td>
    </tr> 
  </tbody>
</table>


</div>

</div> -->
 </div>
</template>

<script>

import MilitaryEducationService from '../../services/academic/MilitaryEducationServices';
import Help from '../Help.vue';
//import ApplicantService from '../../services/Applicant/Applicant.service';

export default {
  components: { Help },
  name: "MilitaryCourses",
  data() {
    return {
     
     Courses:[], 
     empty: false,
     message:'',
     Cancel:false,
     info:[],
    };
  },
 computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
        
        },
  mounted(){

   console.log(this.currenUser.StudentID)
     MilitaryEducationService.GetStudentReservation(this.currenUser.StudentID).then(response=>{
this.Courses = response.data
this.empty =false
  
           }, error => {

              this.empty = true   
              
                  this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
                 
            })


  },
  
  methods:{
     CancelReservation(serial){
        this.$emit('CanceClicked')
    MilitaryEducationService.CancelStudentReservation(serial,this.currenUser.StudentID).then(respone=>{
          console.log(respone.data)
         this.empty=true
        this.Cancel=true
          
        },error=>{
 this.message =
(error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''

        })
  
  },
  Back(){
      this.$router.push("/BookCourse");
    },
  }
}
</script>

<style scoped>

h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
.card-header{
  color: #285475;
  font-size: 21px;

}
.card-title{
    color: #285475;
  font-size: 15px;
  font-weight: bold;

}
.card-text strong{

  color: #285475;
}

.panal{
  background:rgb(255, 255, 255) !important;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
}
.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

.table .thead-light th {
 font-size: 14px;
 width: 15%;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

</style>
